<template>
    <div>
        <div class="content-box first">
            <RsStep class="full m-b-8" :active="1" :steps="['发起分账', '确认并签署合同', '完成分账']"></RsStep>
            <p class="sr-tips" style="margin-bottom: 30px">
                1. 确认每首歌曲的分成的比例
                <br />
                2. 秀动发行结算至你提供的手机号的注册用户
                <br />
                3. 未注册的用户，则系统会暂留该比分成收入，供你分配
            </p>
            <iframe
                :src="info.contractFileFullPath"
                v-loading="pageLoading"
                style="height: 527px; background: #f5f7fa; width: 100%"
                frameborder="0"
                scrolling="no"
            ></iframe>
            <div style="text-align: center; margin-top: 30px">
                <el-button type="primary" :loading="signContractLoading" @click="signContract()">确认签署</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import {getSongsRuleFddContract, signSongsRuleFddContract} from '@/api/distribute';
export default {
    data() {
        return {
            ruleId: '',
            info: {},
            pageLoading: false,
            signContractLoading: false,
        };
    },
    computed: {
        phone() {
            const {telephone} = this;
            return telephone ? telephone.slice(-4) : '';
        },
    },
    mounted() {
        const {
            query: {ruleId},
        } = this.$route;
        if (ruleId) {
            this.ruleId = ruleId;
            this.getContract();
        }
    },
    methods: {
        // 签约等待
        async waitConfirm(status, url) {
            const flag = await this.$fadadaConfirm('合同签署', '请确认是否完成了合同的签署', status == 3 ? 2 : status == 4 ? 1 : status, url);
            if (flag == 'refresh') return this.getContract();
        },
        async getContract() {
            this.pageLoading = true;
            const respnose = await getSongsRuleFddContract(this.ruleId);
            const {state, msg, result} = respnose.data;
            this.pageLoading = false;
            if (!state) return this.$message.error(msg || '获取数据失败,请重试');
            this.info = result;
            const {verifyStatus = 0, signUrl = ''} = result;
            if (this.info.isMiniApp == 3) return this.$message.error('请在小程序端进行相关操作');
            if (verifyStatus == 3) {
                this.$message.success('合同签署成功');
                return this.$router.push({path: `/manage/distribute/detail/3?ruleId=${this.ruleId}`});
            }
            if (verifyStatus != 1) this.waitConfirm(verifyStatus, signUrl);
        },
        // 签署合同
        async signContract() {
            if (this.signContractLoading) return;
            this.signContractLoading = true;
            const {contractCode} = this.info;
            const response = await signSongsRuleFddContract(contractCode, this.ruleId);
            const {state, msg, result} = response.data;
            this.signContractLoading = false;
            if (!state) return this.$message.error(msg || '抱歉，调用签署失败');
            const flag = await this.$msgbox({
                title: '前往电子合同平台“法大大”',
                message: '即将前往电子合同平台“法大大”，在该平台，你将，完成电子合同的签署。',
                confirmButtonText: '确认前往',
            });
            if (flag === 'cancel') return;
            window.open(result);
            this.getContract();
        },
    },
};
</script>
<style lang="scss">
.contract-body {
    .item {
        display: flex;
        margin-top: 10px;

        label {
            width: 60px;
            line-height: 40px;
        }

        .cont {
            flex: 1;
            display: flex;
        }
    }
}
</style>
